import {
    GoogleGenerativeAI,
    // HarmCategory,
    // HarmBlockThreshold,
} from "@google/generative-ai";

// Array of API keys with the primary one first
const API_KEYS = [
    "AIzaSyBqXhfeDgVxbCSr1YAkLIPjxOYBu0KSgVI",
    "AIzaSyADbJZ9vUdWDRwsYi494Whc2bSBHUS34Y8",
    "AIzaSyA7em5l90Nwb2QZiIvDQPv2KO-vgbtnHeY",
    "AIzaSyBEllrtfE8HdZbp8s1M2a7V_ok6teOnsP8",
    "AIzaSyDs7QYxeBsicEBf9W0Hlkkrs8fXHdK9JCg",
    "AIzaSyDxfavsp9YZuY1Q-2XHVl50zqWlsqU28qs",
    "AIzaSyBM9ZM5pyWiLkYI2MzNhRaWcVvDC-76E7k"
];

// Track the current API key index
let currentApiKeyIndex = 0;

// Initialize the API with the first key
let genAI = new GoogleGenerativeAI(API_KEYS[currentApiKeyIndex]);
let model = genAI.getGenerativeModel({
    model: "gemini-2.5-flash",
});

const generationConfig = {
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxOutputTokens: 8192,
    responseMimeType: "text/plain",
};

// Function to switch to the next API key
function switchToNextApiKey() {
    if (currentApiKeyIndex < API_KEYS.length - 1) {
        currentApiKeyIndex++;
        console.log(`Switching to API key ${currentApiKeyIndex + 1}`);
        
        // Reinitialize the API with the new key
        // genAI = new GoogleGenerativeAI(API_KEYS[currentApiKeyIndex]);
        // model = genAI.getGenerativeModel({
        //     model: "gemini-2.5-flash",
        // });
        
        // return true;
    }
    
    console.error("All API keys have failed");
    return false;
}

export async function generateResponse(prompt, imageData) {
    let attempts = 0;
    const maxAttempts = API_KEYS.length;
    
    while (attempts < maxAttempts) {
        try {
            const response = await run(prompt, imageData);
            return response;
        } catch (error) {
            console.error(`Error with API key ${currentApiKeyIndex + 1}:`, error);
            attempts++;
            
            // If we've tried all keys, throw the error
            if (!switchToNextApiKey()) {
                throw new Error("All API keys failed. Please try again later.");
            }
        }
    }
    
    throw new Error("Failed to generate response after trying all API keys.");
}

async function run(prompt, imageData) {
    try {
        // Handle "Who created you?" question directly with more variations
        const lowerPrompt = prompt.toLowerCase().trim();
        if (lowerPrompt === "who created you?" || 
            lowerPrompt.includes("who created you") ||
            lowerPrompt === "who made you?" ||
            lowerPrompt.includes("who made you") ||
            lowerPrompt === "who developed you?" ||
            lowerPrompt.includes("who developed you") ||
            lowerPrompt === "who designed you?" ||
            lowerPrompt.includes("who designed you") ||
            lowerPrompt === "your creator?" ||
            lowerPrompt.includes("your creator") ||
            lowerPrompt === "who is your maker?" ||
            lowerPrompt.includes("who is your maker") ||
            lowerPrompt.includes("who built you")) {
            return "I was created by ChatBox AI.";
        }

        const chatSession = model.startChat({
            generationConfig,
            history: [],
        });

        let response;
        if (imageData) {
            const result = await chatSession.sendMessage([
                {
                    text: prompt,
                },
                {
                    inlineData: {
                        mimeType: imageData.mimeType,
                        data: imageData.imageData
                    }
                }
            ]);
            response = result.response.text();
        } else {
            const result = await chatSession.sendMessage(prompt);
            response = result.response.text();
        }

        // Replace any mention of Google with ChatBox AI (exact capitalization)
        response = response.replace(/\b[Gg]oogle\b/g, "ChatBox AI");
        response = response.replace(/\bChatbox AI\b/g, "ChatBox AI"); // Fix any incorrect capitalization

        // Split response into lines for processing
        const lines = response.split('\n');
        let inCodeBlock = false;
        let codeBlockContent = [];
        let formattedLines = [];

        for (let i = 0; i < lines.length; i++) {
            let line = lines[i];

            // Check for code block markers
            if (line.trim().startsWith('```')) {
                if (!inCodeBlock) {
                    // Start of code block
                    inCodeBlock = true;
                    const language = line.trim().slice(3);
                    codeBlockContent = [];
                    if (language) {
                        codeBlockContent.push(`<div class="code-language">${language}</div>`);
                    }
                } else {
                    // End of code block
                    inCodeBlock = false;
                    const codeContent = codeBlockContent.join('\n');
                    formattedLines.push(
                        `<div class="code-block-container">
                            <div class="code-block">
                                ${codeContent}
                            </div>
                            <button class="code-copy-btn" onclick="copyCode(this)">
                                <span class="copy-icon">📋</span>
                            </button>
                        </div>`
                    );
                }
                continue;
            }

            if (inCodeBlock) {
                // Inside code block - escape HTML and maintain formatting
                codeBlockContent.push(
                    line.replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                );
            } else {
                // Normal text - apply inline formatting
                line = line.replace(/`([^`]+)`/g, '<span class="code-text">$1</span>');
                line = line.replace(/\*\*([^\*]+)\*\*/g, '<strong>$1</strong>');
                line = line.replace(/\*([^\*]+)\*/g, '<em>$1</em>');
                formattedLines.push(line);
            }
        }

        // Add any remaining code block content
        if (inCodeBlock && codeBlockContent.length > 0) {
            formattedLines.push(
                `<div class="code-block-container">
                    <div class="code-block">
                        ${codeBlockContent.join('\n')}
                    </div>
                    <button class="code-copy-btn" onclick="copyCode(this)">
                        <span class="copy-icon">📋</span>
                    </button>
                </div>`
            );
        }

        return formattedLines.join('\n');
    } catch (error) {
        console.error(`Error with API key ${currentApiKeyIndex + 1} in run function:`, error);
        throw error;
    }
}

export default run;